import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncMainMassSchedule({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/MainMassSchedule"));
  console.log("Loading", AsyncMainMassSchedule.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncMainMassSchedule;
